import { Bank2, CreditCard2Front } from "react-bootstrap-icons";

/** Match brand logos from label text like "Visa 1111" / "American Express Ending in 1234". */
export function getCardLogoFromLabel(label: string): string | null {
  const lower = label.toLowerCase();
  if (/\bvisa\b/.test(lower)) return "/img/card-logo-visa.svg";
  if (/\bmastercard\b/.test(lower)) return "/img/card-logo-mastercard.svg";
  if (/\bamex\b/.test(lower) || lower.includes("american express")) {
    return "/img/card-logo-american-express.svg";
  }
  if (/\bdiscover\b/.test(lower)) return "/img/card-logo-discover.png";
  return null;
}

export function last4FromLabel(label: string): string | null {
  const m = label.match(/(\d{4})\s*$/);
  return m?.[1] ?? null;
}

export function inferIsAch(label: string | null | undefined, explicit?: boolean): boolean {
  if (explicit != null) return explicit;
  if (!label) return false;
  const lower = label.toLowerCase();
  return (
    lower.includes("bank") ||
    lower.includes("ach") ||
    lower.includes("checking") ||
    lower.includes("savings")
  );
}

type PaymentMethodBrandLabelProps = {
  label: string;
  isAch?: boolean;
  className?: string;
  /** Compact row for billing cards; default true. */
  compact?: boolean;
};

/** Logo (or bank/card icon) + •••• last4 when brand known; else raw label. */
export function PaymentMethodBrandLabel({
  label,
  isAch: isAchProp,
  className = "",
  compact = true,
}: PaymentMethodBrandLabelProps) {
  const isAch = inferIsAch(label, isAchProp);
  const logo = !isAch ? getCardLogoFromLabel(label) : null;
  const last4 = logo ? last4FromLabel(label) : null;
  const title = last4 ? `•••• ${last4}` : label;
  const iconSize = compact ? 18 : 22;
  const logoBox = compact ? { width: 36, height: 22 } : { width: 48, height: 28 };
  const logoImg = compact
    ? { maxWidth: 36, maxHeight: 22 }
    : { maxWidth: 48, maxHeight: 28 };

  return (
    <div className={`d-flex align-items-center gap-2 ${className}`.trim()}>
      <div
        className="d-flex align-items-center justify-content-center flex-shrink-0"
        style={logoBox}
      >
        {logo ? (
          <img
            src={logo}
            alt=""
            style={{ ...logoImg, objectFit: "contain" }}
          />
        ) : isAch ? (
          <Bank2 size={iconSize} className="text-secondary" />
        ) : (
          <CreditCard2Front size={iconSize} className="text-secondary" />
        )}
      </div>
      <span className={compact ? "text-muted small mb-0" : "fw-semibold"} style={compact ? undefined : { fontSize: "0.92rem" }}>
        {title}
      </span>
    </div>
  );
}
